import darkHaiku from '../assets/dark-haiku.png'
import darkSonnet from '../assets/dark-sonnet.png'
import darkOpus from '../assets/dark-opus.png'
import lightHaiku from '../assets/light-haiku.png'
import lightSonnet from '../assets/light-sonnet.png'
import lightOpus from '../assets/light-opus.png'

const MODEL_ICONS = {
  dark: {
    haiku: darkHaiku,
    sonnet: darkSonnet,
    opus: darkOpus,
  },
  light: {
    haiku: lightHaiku,
    sonnet: lightSonnet,
    opus: lightOpus,
  },
}

export function getModelIcon(modelId: string | undefined, theme: 'light' | 'dark'): string {
  // Default to sonnet if no model specified
  if (!modelId) {
    return MODEL_ICONS[theme].sonnet
  }

  // Handle both full model IDs (claude-haiku-4-5-...) and display names (Haiku)
  const modelLower = modelId.toLowerCase()

  if (modelLower.includes('haiku') || modelLower === 'haiku') {
    return MODEL_ICONS[theme].haiku
  }
  if (modelLower.includes('opus') || modelLower === 'opus') {
    return MODEL_ICONS[theme].opus
  }
  // Default to sonnet
  return MODEL_ICONS[theme].sonnet
}

export function getModelDisplayName(modelId: string | undefined): string {
  if (!modelId) return 'Sonnet'

  // Handle both full model IDs and display names
  const modelLower = modelId.toLowerCase()
  if (modelLower.includes('haiku') || modelLower === 'haiku') return 'Haiku'
  if (modelLower.includes('opus') || modelLower === 'opus') return 'Opus'
  return 'Sonnet'
}
